import Translate from "utils/translate";

const { t } = new Translate();

const assetLeadName = ({ address = "", city = "", name }) =>
  name || `${address}${address && city ? ", " : ""}${city}` || t("undisclosed");

export default assetLeadName;
